import { useEffect, useState } from 'react';
import { fetchGoogleReviews, type GoogleReviewsData } from '../services/googleReviewsApi';

interface UseGoogleReviewsResult {
  data: GoogleReviewsData | null;
  loading: boolean;
  error: boolean;
}

export const useGoogleReviews = (): UseGoogleReviewsResult => {
  const [data, setData] = useState<GoogleReviewsData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    let active = true;
    fetchGoogleReviews()
      .then((result) => {
        if (active) setData(result);
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { data, loading, error };
};
